const formatAddress = function(address) {
    "use strict";
    if (address && address.indexOf(TYROOLA.globals.country) < 0) {
        address += ' ' + TYROOLA.globals.country;
    }

    return address;
};

export default formatAddress;
